import gql from 'graphql-tag'

export const markTransactionPaid = gql`
  mutation MarkTransactionPaid($transactionId: String!) {
    markTransactionPaid(transactionId: $transactionId) {
      code
      message
      transId
      redirect
    }
  }
`
